import { render } from "./arki-requests-list-view.vue?vue&type=template&id=0bdfa6a2"
import script from "./arki-requests-list-view.vue?vue&type=script&setup=true&lang=js"
export * from "./arki-requests-list-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/arki/views/request/arki-requests-list-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bdfa6a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bdfa6a2', __exports__)) {
    api.reload('0bdfa6a2', __exports__)
  }
  
  module.hot.accept("./arki-requests-list-view.vue?vue&type=template&id=0bdfa6a2", () => {
    api.rerender('0bdfa6a2', render)
  })

}


export default __exports__